export default __webpack_public_path__ + "static/media/MOBI.edebc64c.svg";